import { Box, Card, CardContent, styled, Typography } from "@mui/material";

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ theme, esLayoutMobile }) => ({
  display: "flex",
  flexDirection: "column",
  height: !esLayoutMobile ? "100%" : "100%",
  marginBottom: 5,
  justifyContent: esLayoutMobile ? "flex-end" : "space-between",
}));

export const WelcomeText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ theme, esLayoutMobile }) => ({
  fontSize: esLayoutMobile ? 12 : 18,
  margin: esLayoutMobile ? 5 : 15,
  textAlign: "center",
  backgroundColor: "#f2f0f2",
  padding: 10,
  borderRadius: 10,
  marginTop: esLayoutMobile ? 0 : 145,
  border: "2px solid #636262",
}));

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ esLayoutMobile }) => ({
  backgroundColor: "#f2f0f2",
  width: "100%",
  height: "100%",
  borderRadius: 10,
  boxShadow: 2,
  marginTop: 15,
  marginBottom: esLayoutMobile ? 25 : 45,
}));

export const CardHeader = styled(Box)({
  backgroundColor: "rgba(42, 93, 247, 0.75)",
  borderRadius: "10px 10px 0px 0px",
  padding: 5,
});

export const CardHeaderText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ theme, esLayoutMobile }) => ({
  color: "white",
  marginLeft: 20,
  fontSize: esLayoutMobile ? 14 : 16,
  fontWeight: "bold",
}));

export const StyledCardContent = styled(CardContent, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ esLayoutMobile }) => ({
  height: !esLayoutMobile ? "100%" : "90%",
  marginBottom: !esLayoutMobile ? 20 : 0,
  padding: 5,
  borderRadius: 10,
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
}));

export const MessagesContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ esLayoutMobile }) => ({
  backgroundColor: "rgba(255, 255, 255, 0.76)",
  border: "1px solid rgba(189, 182, 182, 0.27)",
  borderRadius: 10,
  padding: 5,
  marginBottom: !esLayoutMobile ? 15 : 5,
  height: "100%",
  overflow: "auto",
  maxHeight: "100%",
}));

export const MessageBox = styled(Box)({
  backgroundColor: "#f2f0f2",
  borderRadius: 10,
  padding: 5,
  margin: 5,
  boxShadow: 1,
});

export const MessageText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "esLayoutMobile",
})(({ esLayoutMobile }) => ({
  fontSize: esLayoutMobile ? 12.5 : 14,
}));

export const MessageTime = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  fontSize: "10px",
  color: "#777",
});
